import { jsx as a, jsxs as p } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { c as h } from "./cn-DlLpp5ix.js";
const f = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 16
}, u = m(function({ size: t = "sm", tone: r = "currentColor", className: o, style: c, ...i }, s) {
  const e = f[t], l = r === "accent" ? "var(--accent-default)" : "currentColor", n = i["aria-label"], d = {
    display: "inline-flex",
    width: e,
    height: e,
    flexShrink: 0,
    color: r === "accent" ? "var(--accent-default)" : void 0,
    ...c
  };
  return /* @__PURE__ */ a(
    "span",
    {
      ref: s,
      "data-ls-component": "spinner",
      "data-size": t,
      "data-tone": r,
      role: n ? "status" : void 0,
      "aria-live": n ? "polite" : void 0,
      className: h("ls-spin", o),
      style: d,
      ...i,
      children: /* @__PURE__ */ p(
        "svg",
        {
          viewBox: "0 0 24 24",
          width: e,
          height: e,
          fill: "none",
          stroke: l,
          strokeWidth: 3,
          strokeLinecap: "round",
          "aria-hidden": "true",
          children: [
            /* @__PURE__ */ a("circle", { cx: "12", cy: "12", r: "9", opacity: 0.25 }),
            /* @__PURE__ */ a("path", { d: "M21 12 a9 9 0 0 1 -9 9" })
          ]
        }
      )
    }
  );
});
u.displayName = "Spinner";
export {
  u as S
};
//# sourceMappingURL=Spinner-X8fu7gHm.js.map
